<template>
  <div class="new_vip">
    <div class="stat_box" style="width: 100%;">
      <div class="stat_item2" style="width: 100%;">
        <div class="stat_item_title">
          账户统计
        </div>
        <div class="stat_item_value2">
          <div class="item_value_part">
            <div class="part_name">账户余额</div>
            <div class="part_value">
              {{ settle.balance || "0.00" }}
              <span>元</span>
            </div>
            <el-button size="small" @click="show_input = true"
              >去充值</el-button
            >
          </div>
          <div class="part_line" style="height: 60px;"></div>
          <div class="item_value_part" style="flex: 4">
            <div class="part_name">总增加</div>
            <div class="part_value">
              {{ settle.total_inc || "0.00" }}
              <span>元</span>
            </div>
          </div>
          <div class="part_line" style="height: 60px;"></div>
          <div class="item_value_part" style="flex: 4">
            <div class="part_name">总减少</div>
            <div class="part_value">
              {{ settle.total_dec || "0.00" }}
              <span>元</span>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="content" style="margin-bottom: 10px;">
      <div class="options">
        <el-form :model="params" inline label-width="90px">
          <!-- 3.13修改顶部筛选 -->
          <el-form-item label="创建时间">
            <el-date-picker
              v-model="dateValue"
              type="datetimerange"
              :picker-options="pickerOptions"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd HH:mm:ss"
              align="right"
              @change="timeDate($event, 1)"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item label="变动类型">
            <el-select v-model="params.type" clearable placeholder="请选择" @change="select_type">
              <el-option label="减少" :value="2"> </el-option>
              <el-option label="增加" :value="1"> </el-option>
            </el-select>
          </el-form-item>
<!--          <el-form-item>-->
<!--            <el-button-->
<!--              style="margin-left: 20px"-->
<!--              type="primary"-->
<!--              @click="timeSearch('search')"-->
<!--              >搜索</el-button-->
<!--            >-->
<!--          </el-form-item>-->
        </el-form>
      </div>
    </div>

    <div class="content">
      <div>变动记录</div>
      <div class="table_box" id="printbox">
        <el-table
          ref="multipleTable"
          :data="tableData"
          v-loading="tableLoading"
          :header-cell-style="setTableHeader"
          element-loading-text="正在查询..."
          border
        >
          <el-table-column type="selection" fixed></el-table-column>
          <el-table-column
            label="变动金额"
            align="center"
            prop="amount"
          ></el-table-column>
          <el-table-column
            label="账户剩余"
            align="center"
            prop="balance"
          ></el-table-column>
          <el-table-column label="变动类型" prop="type" align="center">
            <template slot-scope="scope">
              {{ scope.row.type == 2 ? "减少" : "增加" }}
            </template>
          </el-table-column>
          <el-table-column
            label="变动说明"
            prop="text"
            align="center"
          ></el-table-column>
          <el-table-column label="创建时间" prop="create_time" align="center">
          </el-table-column>
        </el-table>
      </div>
      <!-- 分页按钮 -->
      <div class="page">
        <el-pagination
          layout="prev, pager, next, total, jumper"
          :current-page="page"
          :total="total"
          @current-change="handleCurrentChange"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      width="350px"
      center
      append-to-body
      destroy-on-close
      :before-close="beforeClose"
      @close="show_input = false"
      title="设置充值金额"
      :visible.sync="show_input"
    >
      <el-input placeholder="请输入充值金额,最低不小于300元" v-model="money">
        <template slot="append">元</template>
      </el-input>
      <span slot="footer" class="dialog-footer">
        <el-button @click="show_input = false">关 闭</el-button>
        <el-button type="primary" @click="recheng">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      width="400px"
      center
      append-to-body
      destroy-on-close
      :before-close="beforeClose"
      title="充值付款码"
      :visible.sync="show_settle_code"
    >
      <div id="qrcode"></div>
    </el-dialog>
  </div>
</template>

<script>
import {
  app_recharge,
  app_recharge_logs,
  app_recharge_status,
  app_wallet
} from "@/api/integralMall";
import { mapGetters } from "vuex";
import QRCode from "qrcodejs2";
export default {
  computed: {
    ...mapGetters(["token", "app_id"])
  },
  data() {
    return {
      settlement_date: [],
      money: "",
      tableLoading: false,
      pickerOptions: {
        shortcuts: [
          {
            text: "最近一周",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近一个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30);
              picker.$emit("pick", [start, end]);
            }
          },
          {
            text: "最近三个月",
            onClick(picker) {
              const end = new Date();
              const start = new Date();
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 90);
              picker.$emit("pick", [start, end]);
            }
          }
        ]
      },
      params: {},
      tableData: [],
      dateValue: [],
      settle: {},
      page: 1,
      total: 0,
      show_settle_code: false,
      order: "",
      timer: null,
      show_input: false
    };
  },
  mounted() {
    this._init_();
  },
  methods: {
    _init_() {
      this.getDetail();
      this.getsettlement_detail_count();
    },
    select_type(e){
      if(e){
        this.params.type = e
      }else {
        delete this.params.type
      }
      this.getDetail()
    },
    recheng() {
      if (!this.money || Number(this.money) < 300) {
        return this.$message.error("请确保输入金额不小于300元");
      }
      let ntime = new Date().getTime();
      this.order = `${this.app_id}${ntime}${Math.floor(Math.random() * 10000)}`;
      app_recharge({
        nonce: this.order,
        app_id: this.app_id,
        money: Number(this.money)
      }).then(res => {
        if (res.code == 200) {
          this.show_settle_code = true;
          this.$nextTick(() => {
            new QRCode("qrcode", {
              text: res.data,
              width: 345,
              height: 345
            });
          });
          this.timer = setInterval(() => {
            app_recharge_status({
              app_id: this.app_id,
              nonce: this.order
            }).then(status => {
              if (status.code == 200) {
                this.$message.success("支付成功");
                clearInterval(this.timer);
                this.timer = null;
                this.money = "";
                this.show_input = false;
                this._init_();
                this.show_settle_code = false;
              }
            });
          }, 2000);
        } else {
          this.$message.warning(res.msg);
        }
      });
    },
    beforeClose(done) {
      clearInterval(this.timer);
      this.timer = null;
      done();
    },
    async getDetail() {
      const res = await app_recharge_logs({
        app_id: this.app_id,
        page: this.page,
        ...this.params
      });
      this.tableData = res.data.data;
      this.total = res.data.total;
    },
    async getsettlement_detail_count() {
      const res = await app_wallet({
        app_id: this.app_id
      });
      this.settle = res.data;
    },
    timeDate(val) {
      if (val) {
        this.params.create_time_e = val[1];
        this.params.create_time_s = val[0];
      } else {
        delete this.params.create_time_e
        delete this.params.create_time_s;
      }
      this.getDetail();
    },
    timeSearch(val) {
      console.log(val);
      if (this.$route.query.id == 2) {
        this.getDetail();
      }
    },
    handleCurrentChange(val) {
      console.log(val);
      this.page = val;
      this.getDetail();
    }
  }
};
</script>

<style lang="scss" scoped>
.new_vip {
  padding: 10px 50px 0 15px;
  height: 100%;
  background: #f1f2f6;
  overflow: auto;
  .content {
    background: #fff;
    padding: 15px;
    // display: flex;
    // flex-direction: column;
    .options {
      .options_item {
        width: 25%;
        display: inline-block;
      }
      // .options_input{
      //   width: 230px;
      // }
      .input_box_small {
        width: 240px;
      }
      .date_picker_box {
        width: 130px;
      }
      .time_picker_box {
        width: 115px;
        margin-right: 8px;
      }
      .inline_title {
        margin-left: 24px;
        margin-right: 12px;
      }
      .emp_search {
        margin-left: 15px;
      }
    }
    .table_box {
      // flex: 1;
      margin-top: 10px;
    }
    .page {
      margin-top: 15px;
    }
  }
  .dialog_option {
    margin-bottom: 15px;
    .options_item {
      display: inline-block;
      margin-left: 18px;
      .item_label {
        margin-right: 10px;
      }
      .select_box {
        width: 140px;
      }
    }
    .button_line {
      margin-top: 15px;
      padding-left: 18px;
    }
  }
  .align_c {
    text-align: center;
  }
  .stat_box {
    display: flex;
    padding: 8px 0;
    justify-content: space-between;
    .stat_item:first-child {
      margin: 0;
    }
    .stat_item {
      width: 9%;
      background: #fff;
      height: 100px;
    }
    .stat_item2 {
      width: 45.5%;
      background: #fff;
      height: 150px;
    }
    .stat_item3 {
      width: 45%;
      background: #fff;
      height: 100px;
    }
    .stat_item_title {
      height: 50px;
      line-height: 29px;
      padding: 10px;
      font-size: 18px;
      border-bottom: 1px solid #f5f5f5;
    }
    .stat_item_value {
      padding: 0px 10px;
      padding-top: 8px;
      font-size: 21px;
      line-height: 21px;
      color: #666;
      display: flex;
      span {
        font-size: 14px;
      }
    }
    .stat_item_value2 {
      text-align: center;
      //line-height: 24px;
      color: #666;
      display: flex;
      align-items: center;
      .item_value_part {
        flex: 5;
        //padding-top: 6px;
        .part_name {
          font-size: 18px;
          height: 30px;
          line-height: 30px;
        }
        .part_value {
          font-size: 22px;
          span {
            font-size: 14px;
          }
        }
      }
      .part_line {
        margin-top: 18px;
        height: 60px;
        border-right: 1px solid #ddd;
      }
    }
    .stat_item_value3 {
      color: #666;
      display: flex;
      .item_value_part {
        padding-left: 10px;
        flex: 1;
        padding-top: 7px;
        .part_value {
          font-size: 20px;
          line-height: 26px;
          span {
            font-size: 13px;
          }
        }
      }
      .part_line {
        margin-top: 18px;
        height: 34px;
        border-right: 1px solid #ddd;
      }
    }
    .stat_item_value4 {
      color: #666;
      display: flex;
      text-align: center;
      .item_value_part {
        flex: 1;
        padding-top: 12px;
        .part_title4 {
          font-size: 13px;
          margin-bottom: 5px;
        }
        .part_value {
          font-size: 20px;
          line-height: 26px;
          span {
            font-size: 13px;
          }
        }
      }
      .part_line {
        margin-top: 18px;
        height: 34px;
        border-right: 1px solid #ddd;
      }
    }
  }
}
.date_picker_delete {
  width: 140px;
}
::v-deep .el-popover,
.el-radio-button:first-child:last-child .el-radio-button__inner {
  border-radius: 0;
}
::v-deep .el-radio-button:last-child .el-radio-button__inner {
  border-radius: 0;
}
::v-deep .el-radio-button:first-child .el-radio-button__inner {
  border-radius: 0;
}
a {
  color: #00a4ff;
}
a:hover {
  cursor: pointer;
  border-bottom: 1px solid #00f;
}
</style>
